import { Component, Input } from '@angular/core';

import { User } from '../models';

@Component({
    selector: 'itpx-approval-group-details',
    templateUrl: './approval-group-details.component.html',
    styleUrls: ['./approval-group-details.component.css']
})
export class ApprovalGroupDetailsComponent {

    @Input() data: { approvalGroupMembers: User[] } = null;

    constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/approval-group-details/approval-group-details.component.ts